import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

import styles from './dashboard.module.scss';

export const RightSidebarSkeleton = () => {
  const row = (
    <section className={styles.row}>
      <Skeleton circle={true} height={44} width={44} />
      <Skeleton
        count={1}
        height={18}
        borderRadius={12}
        containerClassName={styles.line}
      />
    </section>
  );

  return (
    <div className={styles['right-sidebar-skeleton']}>
      <SkeletonTheme baseColor="#dedede" highlightColor="#ececec">
        <section className={styles.rows}>
          {row}
          {row}
          {row}
        </section>
      </SkeletonTheme>
    </div>
  );
};

export const LeftSidebarTopSkeleton = () => {
  return (
    <div className={styles['left-sidebar-top-skeleton']}>
      <SkeletonTheme baseColor="#dedede" highlightColor="#ececec">
        <section className={styles.row}>
          <Skeleton circle={true} height={44} width={44} />
          <div className={styles.lines}>
            <Skeleton
              width={160}
              height={12}
              borderRadius={12}
              containerClassName={styles.line}
            />
            <Skeleton
              width={132}
              height={8}
              borderRadius={12}
              containerClassName={styles.line}
            />
          </div>
        </section>
      </SkeletonTheme>
    </div>
  );
};

export const LeftSidebarBottomSkeleton = () => {
  const row = (
    <section className={styles.row}>
      <Skeleton circle={true} height={44} width={44} />
      <div className={styles.lines}>
        <Skeleton
          count={2}
          width={132}
          height={8}
          borderRadius={12}
          containerClassName={styles.line}
        />
      </div>
    </section>
  );

  return (
    <div className={styles['left-sidebar-bottom-skeleton']}>
      <SkeletonTheme baseColor="#dedede" highlightColor="#ececec">
        {row}
        {row}
        {row}
        {row}
        {row}
        {row}
        {row}
      </SkeletonTheme>
    </div>
  );
};

export const MatchesSkeleton = () => {
  const line = (
    <Skeleton
      count={2}
      height={88}
      borderRadius={20}
      containerClassName={styles.line3}
      className={styles.innerLine}
    />
  );

  return (
    <div className={styles['matches-skeleton']}>
      <SkeletonTheme baseColor="#dedede" highlightColor="#ececec">
        <Skeleton
          height={16}
          borderRadius={8}
          width={150}
          className={styles.line1}
        />
        <Skeleton height={10} borderRadius={4} className={styles.line2} />
        <Skeleton height={8} borderRadius={4} width={240} />
        <section className={styles.row}>{line}</section>
        <Skeleton height={58} borderRadius={12} className={styles.button} />
        <Skeleton width={200} height={12} borderRadius={8} />
      </SkeletonTheme>
    </div>
  );
};

export const TodoSkeleton = () => {
  return (
    <div className={styles['todo-skeleton']}>
      <SkeletonTheme baseColor="#dedede" highlightColor="#ececec">
        <section className={styles.row}>
          <Skeleton circle={true} height={44} width={44} />
          <div className={styles.lines}>
            <Skeleton
              width={160}
              height={12}
              borderRadius={12}
              containerClassName={styles.line}
            />
            <Skeleton
              width={132}
              height={8}
              borderRadius={12}
              containerClassName={styles.line}
            />
          </div>
        </section>
        <Skeleton
          height={12}
          borderRadius={12}
          containerClassName={styles.line2}
        />
        <div className={styles.bottom}>
          <div className={styles.left}>
            <Skeleton width={160} height={12} borderRadius={12} />
            <Skeleton height={8} borderRadius={12} />
          </div>
          <Skeleton width={96} height={40} borderRadius={8} />
          <Skeleton width={48} height={40} borderRadius={8} />
        </div>
      </SkeletonTheme>
    </div>
  );
};

export const MatchCardsSkeleton = () => {
  const row = (
    <section className={styles.row}>
      <Skeleton circle={true} height={44} width={44} />
      <div className={styles.lines}>
        <Skeleton height={12} borderRadius={12} />
        <Skeleton height={8} borderRadius={12} width={200} />
        <Skeleton
          count={3}
          height={18}
          width={80}
          borderRadius={12}
          containerClassName={styles.footer}
        />
      </div>
    </section>
  );

  return (
    <div className={styles['match-cards-skeleton']}>
      <SkeletonTheme baseColor="#dedede" highlightColor="#ececec">
        {row}
        {row}
        {row}
      </SkeletonTheme>
    </div>
  );
};
